import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import SearchSummary from '../SearchSummary';

const messages = defineMessages({
  noInstrumentResults: {
    id: 'searchPanel.noInstrumentResults',
    defaultMessage: 'No {instrument} search results.',
  },
  noResults: { id: 'searchPanel.noResults', defaultMessage: 'No search results.' },
});

function getInstrumentButtons(instruments, query, instantSearch, updateFilters) {
  return (
    <div className="pv3 tc">
      {instruments && instruments.current
        ? instruments.items.map(instrument => (
            <button
              type="button"
              className={`br2 pv2 source-sans f6 mh1 ttc pointer outline-0 ${
                instrument.id === instruments.current
                  ? 'bn bg-blue white'
                  : 'b--moon-gray bg-white gray'
              }`}
              data-id={`search-panel-results-${instrument.id}`}
              key={instrument.id}
              onClick={() => {
                updateFilters({ instrument: instrument.id });
                instantSearch(query);
              }}
            >
              <span className="pb1 ph1">
                {instrument.title} ({instrument.subTitle})
              </span>
            </button>
          ))
        : null}
    </div>
  );
}

const SearchPanelResults = ({ hits, instantSearch, instruments, intl, query, updateFilters }) => {
  const { formatMessage } = intl;
  const instrumentButtons = getInstrumentButtons(instruments, query, instantSearch, updateFilters);
  if (hits.length) {
    return (
      <div className="ph3 overflow-auto vh-50" data-id="search-panel-results">
        {instrumentButtons}
        <SearchSummary small />
      </div>
    );
  }
  if (!instruments) {
    return (
      <div className="tc source-sans vh-50 pv3" data-id="search-panel-results-none">
        {formatMessage(messages.noResults)}
      </div>
    );
  }
  return (
    <div className="tc source-sans vh-50" data-id="search-panel-results-no-instrument">
      {instrumentButtons}
      {formatMessage(messages.noInstrumentResults, { instrument: instruments.current })}
    </div>
  );
};

SearchPanelResults.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.shape({})),
  instantSearch: PropTypes.func.isRequired,
  instruments: PropTypes.shape({}),
  intl: intlShape.isRequired,
  query: PropTypes.string,
  updateFilters: PropTypes.func.isRequired,
};

SearchPanelResults.defaultProps = {
  hits: null,
  instruments: null,
  query: '',
};

export default injectIntl(SearchPanelResults);
